import { createFileRoute, Outlet } from '@tanstack/react-router';

// 单个 homework 的布局。详情（index）和教师批改页
// （submissions/$sid）均通过此 Outlet 渲染。`homeworks_` 脱离
// /homeworks 列表（无 Outlet）；此 Outlet 使嵌套的
// 批改页得以挂载——没有它该页永远不会渲染。
export const Route = createFileRoute('/_learner/homeworks_/$id')({
  component: () => <Outlet />,
});
